// extracted by css-extract-rspack-plugin
export default {"cls1":"PingAnswerStyles-cls1_Hhk","cls2":"PingAnswerStyles-cls2_cGZ PingAnswerStyles-cls1_Hhk"};